import * as React from "react";
import ReactHtmlParser from 'react-html-parser';

export interface HorizontalRulerProps {
  formFieldDefinition: any; 
}

export const HorizontalRuler = (props: HorizontalRulerProps) => {
    return <div className="horizontal-ruler"></div>;
};